var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"guang",style:({'--bg-color':_vm.bgColor}),attrs:{"to":{name:_vm.href}}},[_c('label',{staticStyle:{"height":"100%","width":"100%","display":"flex","justify-content":"center","align-items":"center"}},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }